import axios from "axios";
import { CONST } from "../config/const";

export interface ProductPartnerResultResponse {
  mode: "monthly" | "daily";
  headers: string[];
  total: number[];
  total_shot?: number[];   // 日別: 全体日別ショット配列
  total_stock?: number[];  // 日別: 全体日別ストック配列
  count_data: number;
  total_period_total?: number;    // 月別: 全体累計合計
  total_period_total_shot?: number;   // 月別: 全体累計合計（ショット）
  total_period_total_stock?: number;  // 月別: 全体累計合計（ストック）
  total_month_total?: number;     // 日別: 全体指定月合計
  total_month_total_shot?: number;    // 日別: 全体指定月合計（ショット）
  total_month_total_stock?: number;   // 日別: 全体指定月合計（ストック）
  total_month_forecast?: number;  // 日別: 全体指定月見込
  total_month_forecast_shot?: number;  // 日別: 全体指定月見込（ショット）
  total_month_forecast_stock?: number; // 日別: 全体指定月見込（ストック）
  rows: {
    product_name: string;
    product_id: number;
    high_rank_company_name: string;
    high_rank_company_id: number;
    partners: {
      sale_company_name: string;
      sale_company_id: number;
      counts: number[];
      period_total?: number;    // 月別: 累計合計
      period_total_shot?: number;   // 月別: 累計合計（ショット）
      period_total_stock?: number;  // 月別: 累計合計（ストック）
      month_total?: number;     // 日別: 指定月合計
      month_total_shot?: number;    // 日別: 指定月合計（ショット）
      month_total_stock?: number;   // 日別: 指定月合計（ストック）
      month_forecast?: number;  // 日別: 指定月見込
      month_forecast_shot?: number;  // 日別: 指定月見込（ショット）
      month_forecast_stock?: number; // 日別: 指定月見込（ストック）
    }[];
  }[];
}

export async function getProductPartnerResult(params: {
  mode: "monthly" | "daily";
  start_month?: string;
  end_month?: string;
  year_month?: string;
  partner_ids?: string;
  high_rank_company_ids?: string;
  product_ids?: string;
  displayNumber?: string;
  pageNumber?: string;
}): Promise<ProductPartnerResultResponse | null> {
  try {
    const response = await axios.get(CONST.apiUrl2 + "productPartnerResult", {
      params,
    });
    if (!response.data || !response.data.fetch_data) return null;
    return response.data.fetch_data as ProductPartnerResultResponse;
  } catch (error) {
    return null;
  }
}
